// Packages
import { useEffect, useState } from 'react';

// Components
import AdminLayout from 'layouts/Admin';
import BookingsList from 'modules/Bookings/components/List';
import BTDButton from 'components/BTDUI/BTDButton';
import BTDPagination from 'components/BTDUI/BTDPagination';
import DeletedBookingsList from 'modules/Bookings/components/DeletedList';

// Other
import useApi from 'hooks/useApi';
import './styles.css';

const BookingListScreen = () => {

    const [bookings, setBookings] = useState([]);
    const [page, setPage] = useState(1);
    const [query, setQuery] = useState('');

    const { data: items, isLoading, meta, onChange } = useApi('/orders?page=' + page);
    const { data: deletedItems, get: getDeletedItems, deletedItemsLoading, } = useApi('/orders/deleted', false);
    const { data: searchItems, isLoading: searchLoading, get: search } = useApi('/orders/search?query=' + query, false);
    const { data: customerCSV, get: getCSV } = useApi('/orders/customer-csv', false);

    useEffect(() => {

        if(query && query !== '') {

            setBookings(searchItems)
        }
        else {

            setBookings(items)
        }
    }, [items, searchItems])

    useEffect(() => {

        if (customerCSV && customerCSV.length !== 0) {

            const blob = new Blob([customerCSV], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'ANZA AdBookings Customers.csv';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }

    }, [customerCSV])

    return(
        <AdminLayout>

            <h2 style={{marginTop: '35px'}}>Bookings</h2>

            <div className='BookingList__search'>

                <form 
                    className='BookingList__search__form'
                    onSubmit={(e) => {
                        e.preventDefault();
                        setPage(1);
                        search();
                    }}
                >
                    <div style={{maxWidth: 'max-content'}}>
                        <span className='BookingList__search__form__text'>Search by organisation (hit enter):{<>&nbsp;&nbsp;&nbsp;</>}</span>
                    </div>
                    <div style={{marginRight: '20px', maxWidth: '400px', width: '100%'}}>
                        <input className='BookingList__search__form__input' onChange={(e) => {setQuery(e.target.value)}}/>
                    </div>
                </form>

                <div className='flex'>

                    <BTDButton
                        className='BookingList__search__button'
                        colour='orange'
                        label='Customer CSV'
                        onClick={() => getCSV()}
                        size='small'
                        style={{marginRight: '20px'}}
                    />

                    <BTDButton
                        className='BookingList__search__button'
                        label='Create Booking'
                        url='/admin/bookings/create'
                        size='small'
                    />
                </div>
            </div>


            {meta && meta.length !== 0 && searchItems.length === 0 &&
                <p style={{marginBottom: '40px'}}>Showing bookings {meta.from} to {meta.to} of {meta.total}</p>
            }
            
            <BookingsList 
                isLoading={isLoading || searchLoading}  
                items={bookings} 
            />

            {meta && meta.length !== 0 && searchItems.length === 0 &&
                <BTDPagination
                currentPage={meta.current_page}
                onChange={(value) => {
                    setPage(value)
                    onChange()}
                }
                totalPages={Math.ceil(meta.total / meta.per_page)}
                style={{margin: '20px auto 60px auto', width: 'max-content'}}
                />
            }

            <BTDButton
                className='BookingList__search__button'
                label='Show Deleted Bookings'
                size='small'
                onClick={() => {
                    getDeletedItems()
                }}
                style={{marginBottom: '20px', opacity: '0.3'}}
            />

            {deletedItems && deletedItems.length !== 0 &&
                <DeletedBookingsList 
                    isLoading={deletedItemsLoading}  
                    items={deletedItems} 
                    onChange={() => {
                        getDeletedItems();
                        onChange();
                        }
                    }
                />
            }

        </AdminLayout>
    )

}

export default BookingListScreen;